import produce from 'immer';

import { types } from '../actions/resources.actions';
import { RESOURCE_LOADED_STATUS } from '../sagas/resources.saga';

const initialState = {
  loadingStatus: {},
  offlineMode: false,
};

const addResources = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    const { name, fileDetails } = payload;
    draftState[name] = fileDetails;
  });

const updateResourceLoadingStatus = (
  state: any,
  payload: any,
  status: string
) =>
  produce(state, (draftState: any) => {
    draftState.loadingStatus[payload] = status;
  });

const updateKeyValue = (state: any, key: string, value: string) =>
  produce(state, (draftState: any) => {
    draftState[key] = value;
  });

const setResourcesFromApi = (state: any, payload: any) =>
  produce(state, (draftState: any) => {
    if (payload && payload.resources) {
      Object.entries(payload.resources).forEach(([key, value]) => {
        draftState[key] = value;
      });
    }
  });

const reducer = (state = initialState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_EXECUTOR_RESOURCES:
      return addResources(state, payload);
    case types.RESOURCES_LOADING_FOR_LESSON_SUCCESS:
      return updateResourceLoadingStatus(
        state,
        payload,
        RESOURCE_LOADED_STATUS.COMPLETED
      );
    case types.RESOURCES_LOADING_FOR_LESSON_FAILED:
      return updateResourceLoadingStatus(
        state,
        payload,
        RESOURCE_LOADED_STATUS.FAILED
      );
    case types.SET_PLAYER_ROLE:
      return updateKeyValue(state, 'role', payload);
    case types.SET_PLAYER_MODE:
      return updateKeyValue(state, 'mode', payload);
    case types.SET_RESOURCES_FROM_API:
      return setResourcesFromApi(state, payload);
    case types.SET_OFFLINE_MODE:
      return produce(state, (draftState: any) => {
        draftState.offlineMode = payload;
      });
    default:
      return state;
  }
};

export default reducer;
